import React from 'react';

import styles from './StatisticsExterior.module.scss';
import {Accordion, Col, Container, Row} from 'react-bootstrap';
import { useTranslate } from 'react-polyglot';
import ExteriorCardPercentTitles from "./ExteriorCardPercentTitles/ExteriorCardPercentTitles";

function StatisticsExterior(props: StatisticsExteriorProps) {

    const [hasDataPercentage, setHasDataPercentage] = React.useState<boolean>(true);

    React.useEffect(() => {
        props.onDataLoaded?.(hasDataPercentage );
    }, [hasDataPercentage]);

    return (
        <div className={styles.statisticsrelationship}>
            <Container className={styles.container}>
                <Row className={styles.row}>
                    <Col
                        sm="12"
                        md="6"
                        className={styles.col}
                        style={{
                            display:
                                hasDataPercentage
                                    ? "block" : "none"
                        }}
                    >
                    <ExteriorCardPercentTitles
                        onDataLoaded={(data) => {
                            if (data.length != 0) {
                                setHasDataPercentage(true);
                            } else {
                                setHasDataPercentage(false);
                            }
                        }} />
                    </Col>

                </Row>
            </Container>
        </div>
    );
}


class StatisticsExteriorProps {
    onDataLoaded?: (hasData: boolean) => void;
}

export default StatisticsExterior;
